import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import DashboardRequestService from 'services/dashboard-request';
import "./style.scss";
import { ItemCardRanking } from './utils';
import Axios from 'axios';

export default function ({
  onOpenDashboard,
  fiscalYear
}) {
  const [loading, setLoading] = useState(false)
  const [ranking, setRanking] = useState([]);
  const refCard = useRef()
  const refArea = useRef()

  useEffect(() => {
    let aux_token_cancel_request = Axios.CancelToken.source();

    setLoading(true)
    DashboardRequestService.getRankingTechnologiesByPos(fiscalYear.id, [1, 2, 3], aux_token_cancel_request.token)
      .then(({ data }) => {
        setRanking(data);
        // setIndex(0)
      })
      .finally(() => setLoading(false))

    return ()=>{
      aux_token_cancel_request.cancel('');
    }
  }, [fiscalYear]);

  useLayoutEffect(() => {
    let id1 = null
    let id2 = null

    function move(a, c, index) {
      let center = new ItemCardRanking(ranking[index]);
      a.innerHTML = center.render();
      let wc = center.box().width;
      center.setStyleCenter()

      let items_left = [];
      let il = index - 1;
      let wl = 0;

      let items_right = [];
      let ir = index + 1;
      let wr = 0;

      const width_max = parseInt((c.offsetWidth - wc) / 2);

      while (wl < width_max) {
        if (il < 0) {
          il = ranking.length - 1;
        }
        const item = new ItemCardRanking(ranking[il--]);
        items_left.push(item);
        a.innerHTML = item.render() + a.innerHTML;
        if (items_left.length === 1) {
          item.setStylePreCenter();
        }
        wl = items_left.reduce((a, b) => a + b.box().width, 0);
      }

      let dif = wl - width_max
      items_left[items_left.length - 1].target().style.marginLeft = -dif + "px"

      while (wr < width_max) {
        if (ir >= ranking.length) {
          ir = 0;
        }
        const item = new ItemCardRanking(ranking[ir++]);
        a.innerHTML += item.render();
        items_right.push(item)
        if (items_right.length === 1) {
          item.setStylePreCenter();
        }
        wr = items_right.reduce((a, b) => a + b.box().width, 0);
      }

      id1 = setTimeout(() => {
        items_left.unshift(center);
        wl = items_left.reduce((a, b) => a + b.box().width, 0);
        let new_center = items_right.shift();
        wr = items_right.reduce((a, b) => a + b.box().width, 0);
        const new_width_max = parseInt((c.offsetWidth - new_center.box().width) / 2);
        while (wr < new_width_max) {
          if (ir >= ranking.length) {
            ir = 0;
          }
          const item = new ItemCardRanking(ranking[ir++]);
          a.innerHTML += item.render();
          items_right.push(item)
          wr = items_right.reduce((a, b) => a + b.box().width, 0);
        }
        dif = wl - new_width_max;

        items_left[items_left.length - 1].target().style.marginLeft = -dif + "px";

        new_center.setStyleCenter()
        items_left[1].clearStyle();

        items_left[0].setStylePreCenter();
        items_right[0].setStylePreCenter();
      }, 10);
      id2 = setTimeout(() => {
        if (index + 1 < ranking.length) {
          move(a, c, index + 1)
        } else {
          move(a, c, 0)
        }
      }, 8000);
    }

    if (refArea && refArea.current && refCard && refCard.current && ranking.length > 0) {
      const a = refArea.current
      const c = refCard.current
      move(a, c, 0);
    }

    return () => {
      if (id1) clearTimeout(id1)
      if (id2) clearTimeout(id2)
    }
  }, [refCard, refArea, ranking]);

  return (
    <Row>
      <Col xs="12" className='mb-2 pl-1 pr-1'>
        <Card.Body className="card-dashboard shadow bg-white rounded w-100 card-notification p-1 h-100" style={{ overflow: 'hidden' }} ref={refCard}>
          <Row className="mb-2">
            <Col className='d-flex align-items-center'>
              <span className="dashboard-card-h5 text-left p-2">Ranking por categorias</span>
              {loading && <Spinner size="sm" variant="danger" animation="border" role="status" />}
            </Col>
            <Col xs="auto">
              <Button size="sm" onClick={() => {
                if (onOpenDashboard) onOpenDashboard();
              }}>Ver Dashboard Ranking</Button>
            </Col>
          </Row>
          {ranking.length > 0 ? (<>
            <Row className="fade-side">
              <Col xs="12">
                <div className="area-move-ranking" ref={refArea}>
                  {/* {ranking.map((item, key)=>{
                    return (
                      <div className="move-ranking-item" data-key={key} key={key}>
                        <label className="move-ranking-item-technologie-name">{item.technology_name}</label>
                        <label className="move-ranking-item-company-name">{item.company_name}</label>
                        <label className="move-ranking-item-value">{formatMoney(item.value)}</label>
                      </div>
                    );
                  })} */}
                </div>
              </Col>
            </Row>
          </>) : (<>
            <Row className="fade-side d-flex">
              <Col md="12" className='d-flex justify-content-center align-items-center'>
                <h1>Sem dados</h1>
              </Col>
            </Row>
          </>)}
        </Card.Body>
      </Col>
    </Row>
  );
}